<template>
  <div>
    <s-table
      ref="table"
      size="default"
      :rowKey="record => record.id"
      :columns="columns"
      :data="loadData"
      showPagination="auto"
    >
      <span slot="completedAmount" slot-scope="text">{{ text | priceFilter }}</span>
      <span slot="amount" slot-scope="text">{{ text | priceFilter }}</span>
      <span slot="time" slot-scope="text">{{ text | textFilter }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="edit(record)">修改</a>
      </span>
    </s-table>
    <commission-form ref="CommissionForm" @reload="reload" />
  </div>
</template>

<script>
import { STable, Ellipsis } from '@/components'
import CommissionForm from '../../commission/components/CommissionForm'
import { moxiCheckouts } from '@/api/moxi'
import { checkoutColumns, financeCheckoutColumns } from '../js/index'
export default {
  props: {
    detailId: {
      type: String,
      default: ''
    },
    targetAmount: {
      type: String,
      default: ''
    }
  },
  components: {
    STable,
    Ellipsis,
    CommissionForm
  },
  data() {
    return {
      id: null,
      loadData: parameter => {
        return moxiCheckouts(this.dingUserId, this.id).then(res => {
          if (res.success) {
            const result = this.dResDataFormat(res)
            return result
          }
        })
      }
    }
  },
  computed: {
    dingUserId() {
      return this.$store.state.dingUser.data.user_id
    },
    columns() {
      if (this.btnPermission('member_addition')) {
        return financeCheckoutColumns
      } else {
        return checkoutColumns
      }
    }
  },
  created() {
    this.id = this.detailId || this.$route.query.id
  },
  methods: {
    reload() {
      this.tableHome()
      this.$refs.table.refresh()
    },
    edit(record) {
      record.target_amount = this.targetAmount
      this.$refs.CommissionForm.show(record)
    }
  }
}
</script>
